/**
 * Encodes query-string values for navigation URLs.
 *
 * We additionally encode '*' as %2A because some upstream WAF rules treat raw
 * asterisks in query parameters as suspicious patterns. The backend still
 * receives the same logical value after URL decoding.
 */
export function encodeQueryValue(value: string): string {
  return encodeURIComponent(value).replace(/\*/g, '%2A');
}
